"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Login_vue_1 = __importDefault(require("./../../pages/login/Login.vue"));
exports.default = [
    {
        name: "admin_login",
        path: "/admin/login/",
        component: Login_vue_1.default,
        meta: { requiresAuth: false, title: "Login" },
    },
    {
        name: "security_login",
        path: "/api/security/login",
        redirect: "",
        meta: { requiresAuth: false },
    },
    {
        name: "security_logout",
        path: "/api/security/logout",
        redirect: "",
        meta: { requiresAuth: false },
    },
    {
        name: "security_refresh_token",
        path: "/api/security/refresh-token",
        redirect: "",
        meta: { requiresAuth: false },
    },
    {
        name: "security_get_user",
        path: "/api/security/get-user",
        redirect: "",
        meta: { requiresAuth: true },
    },
    {
        name: "security_check_auth",
        path: "/api/security/check-auth",
        redirect: "",
        meta: { requiresAuth: true },
    },
    {
        name: "permissions_api",
        path: "/api/permissions/:id(\\d+)?",
        redirect: "",
        meta: { requiresAuth: true },
    },
    {
        name: "app_gen_auth_code",
        path: "/api/security/app-auth-generate",
        redirect: "",
        meta: { requiresAuth: false },
    },
    {
        name: "app_login",
        path: "/api/security/app-login",
        redirect: "",
        meta: { requiresAuth: false },
    },
];
